import { Button, colors, NoSidebarPageLayout } from '@insurancemenu/imenu-components-lib';
import { CARD_DATA } from 'global/checklists-helpers/ChecklistHelper';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { useFullFormPageStore } from 'store/pages/enrollment/add-employees/full-form/pageStore';
import { toJS } from 'mobx';
import {
  PAGE_FOOTER_BACK_BTN_TEST_ID,
  PAGE_FOOTER_COMPLETE_BTN_TEST_ID,
  PAGE_FOOTER_TEST_ID,
} from '@insurancemenu/imenu-components-lib/dist/components/layouts/constants';
import { useRemoveQueryParams } from 'global/hooks/useRemoveQueryParams';
import { FullFormTabs } from './FullFormTabs';
import { FooterStyled, ValidationErrorsStyled } from './styles';

// TESTING_POLICY: CYPRESS_ONLY

export const PageContent: React.FC = observer(() => {
  const { subscriberExists, aggregatedErrors, electionsModule, getInitialData, onBackRedirect, onAddAnotherEmployee } =
    useFullFormPageStore();

  const removeQueryParams = useRemoveQueryParams();

  async function addAnotherEmployee(): Promise<void> {
    await onAddAnotherEmployee();
    removeQueryParams(['subscriberId', 'activeTabId']);
  }

  useEffect(() => {
    if (electionsModule) {
      void getInitialData();
    }
  }, [electionsModule]);

  return (
    <NoSidebarPageLayout
      pageHeader={{
        title: CARD_DATA.ADD_EMPLOYEES.title,
        subtitle: 'Add an employee with all required details and optionally include dependents and benefit elections.',
        subtitleMaxWidth: '42rem',
        onBackButtonClick: onBackRedirect,
      }}
      pageFooter={
        <FooterStyled data-test-id={PAGE_FOOTER_TEST_ID}>
          <Button
            onClick={onBackRedirect}
            size="large"
            width="24rem"
            type="outlined"
            data-test-id={PAGE_FOOTER_BACK_BTN_TEST_ID}
          >
            Back
          </Button>

          <Button
            color="custom"
            customColor={colors.green[600]}
            onClick={addAnotherEmployee}
            size="large"
            disabled={!subscriberExists}
            width="24rem"
            data-test-id={PAGE_FOOTER_COMPLETE_BTN_TEST_ID}
          >
            Add Another Employee
          </Button>
        </FooterStyled>
      }
    >
      <FullFormTabs />
      <ValidationErrorsStyled
        title="Attention! Resolve the following issue(s) to continue"
        errors={aggregatedErrors.slice().map((error) => toJS(error))}
      />
    </NoSidebarPageLayout>
  );
});
